import { FormProvider, observer, useForm } from "@formily/react";
import { useFormily } from "../../hooks/useFormily";
import { createContext, useContext } from "react";
import { Button } from "../core/basic/Button";
import type { Form } from "@formily/core";
import type React from "react";
import { getModifiedTopLevelValues } from "../../utils/formily";
import { HStack } from "../../../styled-system/jsx";

interface Props {
  children: React.ReactNode;
}

const IsEditableContext = createContext(false);
export const useIsInEditableWrapper = () => useContext(IsEditableContext);

export function EditableTableWrapper({ children }: Props) {
  const form = useFormily({});
  return (
    <FormProvider form={form}>
      <IsEditableContext.Provider value={true}>{children}</IsEditableContext.Provider>
    </FormProvider>
  );
}

type SubmitButtonProps<TEditableRowData> = {
  onSubmit: (
    values: Record<string, TEditableRowData>,
    form: Form<Record<string, TEditableRowData>>,
  ) => void | Promise<void>;
};

const PreObservedSubmitArea = <TEditableRowData,>({ onSubmit }: SubmitButtonProps<TEditableRowData>) => {
  const form = useForm();
  return form.modified ?
      <HStack gap="medium">
        <Button variant="secondary" onPress={() => void form.reset()}>
          Cancel Changes
        </Button>
        <Button
          isPending={form.submitting}
          isDisabled={form.invalid}
          onPress={() => {
            void form.submit(async (values) => {
              const modifiedValues = getModifiedTopLevelValues(values, form);
              await onSubmit(modifiedValues, form);
            });
          }}
        >
          Save Changes
        </Button>
      </HStack>
    : null;
};

export const EditableTableSubmitArea = observer(PreObservedSubmitArea) as typeof PreObservedSubmitArea;
